:host {
  display: block;
}
.col-count-1 {
  column-count: 1;
}

.col-count-2 {
  column-count: 2;
}
